import { render, staticRenderFns } from "./admin_nav.vue?vue&type=template&id=1b2951d2&scoped=true&"
import script from "./admin_nav.vue?vue&type=script&lang=js&"
export * from "./admin_nav.vue?vue&type=script&lang=js&"
import style0 from "./admin_nav.vue?vue&type=style&index=0&id=1b2951d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2951d2",
  null
  
)

export default component.exports